import React, { createContext,useEffect, useContext, useReducer, ReactNode } from 'react';
import { WidgetConfig,Bet } from '../types';
import { STORAGE_VERSION } from '../reducers/state';
import { 
  betReducer 
} from '../reducers/betReducer';

import { getInitialState } from '../reducers/state';
import { VersionedState } from '../reducers/state';
export interface WidgetContextState extends VersionedState {
  id:string,
  dispatch: React.Dispatch<any>;
}
const WidgetContext = createContext<WidgetContextState | undefined>(undefined);

export interface WidgetProviderProps {
  children: ReactNode;
  config: WidgetConfig;
  onStateChanged?: (state: VersionedState) => void;
  initialBets?: Bet[];
  id:string;
};

export const WidgetProvider: React.FC<WidgetProviderProps> = ({ 
  children,
  config ,
  onStateChanged,
  initialBets = [],
  id
}) => {
  
  const [state, dispatch] = useReducer(
    betReducer, 
    getInitialState(initialBets,config)
  );
  useEffect(() => {
      if (onStateChanged) {
        onStateChanged(state);
      }
  }, [state]);
  const contextValue: WidgetContextState = {
    __version: STORAGE_VERSION,
    bets: state.bets || initialBets,
    totalOdds: state.totalOdds,
    config: state.config || config,
    id:id,
    dispatch
  };
  
  return (
    <WidgetContext.Provider value={contextValue}>
      {children}
    </WidgetContext.Provider>
  );
}

// Main unified hook for accessing shared state
export const useWidgetContext = (): WidgetContextState => {
  const context = useContext(WidgetContext);
  if (!context) {
    throw new Error('useWidgetContext must be used within a WidgetProvider');
  }
  return context;
};

export { WidgetContext };


export default WidgetContext;
